var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FilterData } from 'path-shared/models/filter-data';
var FestiusFilter = /** @class */ (function (_super) {
    __extends(FestiusFilter, _super);
    function FestiusFilter(sortField, sortDir) {
        var _this = _super.call(this, sortField, sortDir) || this;
        _this.dia = null;
        _this.descripcio = '';
        _this.tipus = null;
        _this.labels['dia'] = _this.i18n('Dia');
        _this.labels['descripcio'] = _this.i18n('Descripció');
        _this.labels['tipus'] = _this.i18n('Tipus');
        return _this;
    }
    return FestiusFilter;
}(FilterData));
export { FestiusFilter };
